<template>
  <La0 class="setting" :ratio="'1fr 1.3fr'">
    <template slot="left">
    <div class="vips">
      <div>會員稱呼
        <EditBtn  v-if="edit!=='vipName'" @click="edit='vipName';editItem=JSON.parse(JSON.stringify(vipName))" :style="{marginLeft: 'auto'}"/>
        <button  v-if="edit==='vipName'" @click="editItem.splice(editItem.length, 0, { level: editItem.length + 1, zh: null, img: null })" :style="{marginLeft: 'auto', backgroundColor: 'transparent'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M15.9998 32C7.1634 32 0 24.8361 0 15.9998C0 7.16387 7.1634 0 15.9998 0C24.8361 0 32 7.16387 32 15.9998C32 24.8361 24.8361 32 15.9998 32ZM15.9998 29.5995C23.511 29.5995 29.5995 23.511 29.5995 15.9998C29.5995 8.48855 23.511 2.39999 15.9998 2.39999C8.48855 2.39999 2.39999 8.48855 2.39999 15.9998C2.39999 23.511 8.48855 29.5995 15.9998 29.5995ZM17.1998 14.7998H21.9997C22.6625 14.7998 23.1997 15.337 23.1997 15.9998C23.1997 16.6626 22.6625 17.1998 21.9997 17.1998H17.1998V21.9997C17.1998 22.6625 16.6626 23.1997 15.9998 23.1997C15.337 23.1997 14.7998 22.6625 14.7998 21.9997V17.1998H9.9998C9.33699 17.1998 8.7998 16.6626 8.7998 15.9998C8.7998 15.337 9.33699 14.7998 9.9998 14.7998H14.7998V9.9998C14.7998 9.33699 15.337 8.7998 15.9998 8.7998C16.6626 8.7998 17.1998 9.33699 17.1998 9.9998V14.7998Z" fill="var(--color-checked)"/>
          </svg>
        </button>
      </div>
      <div v-if="edit!=='vipName'">
        <div v-for="(vip, v) in vipName" :key="`vip-${v}`"  class="VIP"><span :style="{backgroundImage: `url(.${vip.img})`}"></span> {{vip.zh}}</div>
      </div>
      <div v-else-if="edit==='vipName'">
        <div v-for="(vip, v) in editItem" :key="`vip-${v}`"  class="VIP">
          <input type="text" v-model.number="vip.level" :style="{width: '40px'}">
          <span><FileInput :folder="'vip'" :defaultValue="vip.img" @input="vip.img=$event "/></span>
          <input type="text" v-model="vip.zh">
          <button :style="{backgroundColor: 'transparent', margin:'auto', display:'flex', alignItems:'center'}" @click="editItem.splice(v, 1)">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M16 32C7.1633 32 0 24.8367 0 16C0 7.1633 7.1633 0 16 0C24.8367 0 32 7.1633 32 16C31.9901 24.8327 24.8327 31.9901 16 32ZM16 2.58083C10.5725 2.58083 5.67891 5.85043 3.6023 10.8648C1.52524 15.8792 2.67333 21.6515 6.51135 25.4891C10.3494 29.3271 16.1212 30.4752 21.1356 28.3981C26.15 26.3211 29.4196 21.4279 29.4196 16C29.4111 8.592 23.408 2.58892 16 2.58083ZM22.8387 17.2904H9.16133C8.44877 17.2904 7.87091 16.7126 7.87091 16C7.87091 15.2874 8.44877 14.7096 9.16133 14.7096H22.8387C23.3034 14.7042 23.7353 14.9489 23.9692 15.3503C24.2032 15.7517 24.2032 16.2478 23.9692 16.6493C23.7353 17.0511 23.3034 17.2958 22.8387 17.2904Z" fill="var(--color-checked)"/>
          </svg>
          </button>
        </div>
        <BtnsS @cancel="edit=null" @save="save"/>
      </div>
    </div>
    <div :style="{overflowY: 'auto', marginTop: '78px'}" class="scrollbar">
      <div class="titleName">平/假日設定</div>
      <div class="holidayContent">
        <div>平日 : 一、二、三、四、五</div>
        <div>假日 : 六、日</div>
        <div><span>國定假日 : </span><span :style="{lineHeight: '180%'}">{{holidays2.map(e => e.date2).join(' | ')}}</span></div>
        <!-- <div class="calendars">
            <div class="title">國定假日
            <EditBtn2 v-if="!editHoliday" @click="holidays=JSON.parse(JSON.stringify(holidays2.map(e => e.date)));editHoliday=true"/>
            <BtnsS @cancel="editHoliday=false" @save="saveHoliday" v-else/>
          </div>
          <calendar v-for="i in years" :key="`year-${i}`" :holidays="editHoliday ? holidays : holidays2.map(e => e.date)" @push="push" @pull="pull" :year="moment().year()+(i-1)" :edit="editHoliday">
          </calendar>
          <button class="nextYear" @click="years+=1">下一年</button>
        </div> -->
      </div>
    </div>
    <!-- <editCube :style="{maxWidth: '600px', marginTop: '43px'}" :title="'會員驗證(手機簡訊)'" :keyname="'memberVerify'"
      :template="`【${VUE_APP_STORENAMESHORT}】親愛的會員，您的註冊手機驗證碼為:{OTP}。(注意:驗證碼10分鐘內有效)`"/> -->
    </template>
    <div :style="{overflowY: 'auto'}" class="scrollbar">
      <!-- <div class="titleName">平/假日設定</div> -->
      <div class="holidayContent" :style="{marginTop: 0}">
        <!-- <div>平日 : 一、二、三、四、五</div>
        <div>假日 : 六、日</div> -->
        <!-- <div><span>國定假日 : </span><span :style="{lineHeight: '180%'}">{{holidays2.map(e => e.date2).join(' | ')}}</span></div> -->
        <div class="calendars">
            <div class="title">國定假日
            <EditBtn2 v-if="!editHoliday" @click="holidays=JSON.parse(JSON.stringify(holidays2.map(e => e.date)));editHoliday=true"/>
            <BtnsS @cancel="editHoliday=false" @save="saveHoliday" v-else/>
          </div>
          <calendar v-for="i in years" :key="`year-${i}`" :holidays="editHoliday ? holidays : holidays2.map(e => e.date)" @push="push" @pull="pull" :year="moment().year()+(i-1)" :edit="editHoliday">
          </calendar>
          <button class="nextYear" @click="years+=1">下一年</button>
        </div>
      </div>
    </div>
  </La0>
</template>

<script>
import La0 from '../../components/layout/La0.vue'
import calendar from './calendar.vue'
import EditBtn from '../../components/btn/edit.vue'
import EditBtn2 from '../../components/btn/editConvert.vue'
import FileInput from '../../components/input/file4.vue'
// import editCube from '../../components/editCubeMsg.vue'
import { getapi, postapi, putapi, deleteapi } from '../../store/fetch'
const VUE_APP_STORENAMESHORT = process.env.VUE_APP_STORENAMESHORT
export default {
  components: { La0, calendar, EditBtn2, EditBtn, FileInput },
  data () {
    return {
      VUE_APP_STORENAMESHORT,
      editHoliday: false,
      years: 2,
      holidays2: [],
      holidays: [],
      addholiday: false,
      removeholiday: false,
      vipName: [],
      edit: null,
      editItem: null
    }
  },
  async mounted () {
    this.vipName = await getapi('selections/vipName')
    this.getHolidays()
  },
  methods: {
    async getHolidays () {
      const year = this.moment().year()
      const holidays = await getapi('holidays')
      this.holidays = holidays.map(e => {
        return this.moment(e.date).format('yyyy-MM-DD')
      })
      this.holidays2 = holidays.map(e => {
        return {
          date: this.moment(e.date).format('yyyy-MM-DD'),
          date2: this.moment(e.date).format(this.moment(e.date).year() === year ? 'MM/DD(dddd)' : 'yyyy/MM/DD(dddd)').replace('星期', ''),
          _id: e._id
        }
      })
    },
    async saveHoliday () {
      const holiday2 = this.holidays2.map(e => e.date)
      const holidays = this.holidays.filter(e => !holiday2.includes(e)).map(e => {
        return { date: this.moment(e).toDate() }
      })
      const ret = await putapi('holidays', holidays)
      const delID = this.holidays2.filter(e => !this.holidays.includes(e.date)).map(e => e._id)
      await deleteapi('holidays', { ids: delID })
      if (ret) {
        this.getHolidays()
        this.editHoliday = false
      }
    },
    push (ev) {
      if (this.editHoliday) {
        this.holidays.push(ev)
      }
    },
    pull (ev) {
      if (this.editHoliday) {
        this.holidays.splice(this.holidays.indexOf(ev), 1)
      }
    },
    async save () {
      if (this.edit === 'vipName') {
        const r = await postapi('selections/vipName', { key: 'optionsObj', data: this.editItem })
        if (r) {
          this.vipName = r
          this.edit = null
        }
      }
    }
  }
}
</script>
<style lang="scss">
.setting {
  &>.La0_left {
    border-right: 1px solid #CACACA;
    padding: 40px 40px 40px 80px;
  }
  &>.La0_right {
    padding: 40px 80px 40px 40px;
  }
}
</style>
<style lang="scss" scoped>
.nextYear {
  height: 60px;
  letter-spacing: .2em;
  width: 100%;
}
.calendars {
  border: 5px solid var(--color-checked);
}
.holidayContent {
  text-align: start;
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-block: 30px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #FFFFFF;
    background-color: var(--color-checked);
    font-size: 22px;
    height: 50px;
    padding-inline: 1em;

  }
}
.titleName {
  text-align: start;
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    background-color: transparent;
    border: none;
  }
}
.vips {
  display: flex;
  flex-direction: column;
  width: 300px;
  gap: 20px;
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;
  }
  &>div:nth-child(2) {
    text-align: start;
    font-size: 22px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    letter-spacing: 1px;
    &>div{
      gap: 20px;
      display: flex;
      align-items: center;
    }
  }
}
.VIP {
  display: flex;
  align-items: center;
  gap: .5em;
  font-size: 20px;
  span {
    display: inline-flex;
    min-width: 30px;
    width: 30px;
    height: 30px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  input[type=text] {
    width: 200px;
    border: 1px solid #CACACA;
    height: 40px;
    text-align: center;
    border-radius: 3px;
  }
}
</style>
